import { format } from 'date-fns';
import escapeHtml from 'escape-html';

// String with title case
String.prototype.toProperCase = function () {
  return this.replace(/\w\S*/g, function(txt){
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

const findProp = (prop, obj) => {
  if (typeof obj !== 'object') {
    return null;
  }

  if (obj === null) {
    return null;
  }

  if (obj === undefined) {
    return null;
  }

  if (typeof prop !== 'string') {
    throw Error('Property has to be a string! ');
  }

  let propValue = null;

  if (obj[prop]) {
    return obj[prop];
  }
 
  for (let key in obj) {
    propValue = findProp(prop, obj[key]);
    if (propValue !== null) {
      break;
    }
  }

  return propValue;
};

const findDeepProp = (props, obj) => {
  if (typeof props !== 'string' && !(props instanceof Array)) {
    throw Error('Property has to be a string or array!');
  }

  if (typeof props === 'string') {
    let split = props.split('.');
    return findDeepProp(split, obj);
  }

  const element = props.shift();

  let propValue = findProp(element, obj);
  if (propValue !== null && props.length > 0) {
    propValue = findDeepProp(props, propValue);
  }

  return propValue;
};

// function formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
//   try {
//     decimalCount = Math.abs(decimalCount);
//     decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

//     const negativeSign = amount < 0 ? "-" : "";

//     let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
//     let j = (i.length > 3) ? i.length % 3 : 0;

//     return negativeSign
//       + (j ? i.substr(0, j) + thousands : '')
//       + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1"
//       + thousands)
//       + (decimalCount ? decimal
//       + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
//   } catch (e) {
//     return amount || '';
//   }
// }

const arrayToObject = (arr, keyField) =>
  Object.assign({}, ...arr.map(item => ({ [item[keyField]]: item })));

/*
  this is a helper fn that accepts a data object containing the following:
    - accountNum <String>
    - amountDue <Number>
    - owner <String>
    - address <Object>
      - streetAddress <String>
      - city <String>
      - state <String>
      - postalCode <String>
      - country <String>
  and returns a serialized xml object which the epay gateway can accept for
  initiating a purchase.
  REVIEW does this need to handle credits?
*/

const generateBillingXML = (data) => {
  console.log('generate billing xml', data);

  // if data object is empty, return empty string
  if (Object.keys(data).length < 1) {
    return '';
  }

  // get the current date/time in iso format with timezone
  // 2019-11-21T13:19:27-05:00
  // 2019-11-21 157436024221613:17:22-05:00
  let timestamp = format(new Date(), "yyyy-MM-dd'T'HH:mm:ssxxx");
  console.log('timestamp in realestatetax gb:', timestamp);

  // TODO use a json to xml lib instead of forming this string?
  const xmlString = `<?xml version="1.0" encoding="utf-16"?>
    <BillingStatement xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema">
      <ApplicationID>e4312783-b2bd-493e-af9f-f916b423a0ea</ApplicationID>
      <AccountNumber>${data.caseId}</AccountNumber>
      <BillNumber>${data.billNumber}</BillNumber>
      <StatementNumber />
      <BillingDate>${timestamp}</BillingDate>
      <DueDate>${timestamp}</DueDate>
      <TotalDue>${data.amountOwed}</TotalDue>
      <DepartMentId>0</DepartMentId>
      <Fund>0</Fund>
      <PaymentDate>${timestamp}</PaymentDate>
      <Quantity>0</Quantity>
      <ItemAmount>0</ItemAmount>
      <TotalAmountdue>${data.amountOwed}</TotalAmountdue>
      <PartialPaymentFlag>false</PartialPaymentFlag>
      <ReceiptpresentFlag>false</ReceiptpresentFlag>
      <Description></Description>
      <Details>
        <BillingStatementDetail>
          <ItemDate>${timestamp}</ItemDate>
          <ItemDescription>Notice of violation fine.</ItemDescription>
          <Charges>${data.amountOwed}</Charges>
          <Credits>0</Credits>
        </BillingStatementDetail>
      </Details>
      <Customers>
        <Customer>
          <Organization>${data.firstName} ${data.lastName}</Organization>
          <FirstName>${data.firstName}</FirstName>
          <MiddleName />
          <LastName>${data.lastName}</LastName>
          <BillingAddress>
            <Address>
              <AddressLine1>${data.proprietorAddress}</AddressLine1>
              <City>${data.proprietorCity}</City>
              <State>${data.proprietorState}</State>
              <PostalCode>${data.proprietorZipCode}</PostalCode>
              <Country>${data.proprietorCountry}</Country>
            </Address>
          </BillingAddress>
          <PhoneNumber />
        </Customer>
      </Customers>
      <OtherAttributes>
        <Attribute>
          <Name>Description</Name>
          <Value>Notice of violation fine.</Value>
        </Attribute>
      </OtherAttributes>
      <PayerEmailAddress>${data.proprietorEmail}</PayerEmailAddress>
      <SuccessUrl>${data.sucessURL}</SuccessUrl>
      <FailureUrl>${data.failureURL}</FailureUrl>
    </BillingStatement>`;

  return escapeHtml(xmlString);
};

export {
  // formatMoney,
  arrayToObject,
  findDeepProp,
  generateBillingXML,
};

export default {
  install(vue, { store }) {
    vue.prototype.$helpers = {
      // formatMoney,
      arrayToObject,
      findDeepProp,
      generateBillingXML,
    };
    store.$helpers = vue.prototype.$helpers;
  },
};
